import React, { useState, useEffect } from "react";
import {
    Box,
    Input,
    Button,
    SpaceBetween
} from "@amzn/awsui-components-react";

const RippleMultiInputKeyValue = (props) => {
    var [rows, setRows] = useState(null);
    useEffect(() => {
        loadRows()
        return () => {
        };
    }, []);

    useEffect(() => {
        if (props.reload) {
            loadRows()
            props.resetReload(false)
        }
        return () => {
        };
    }, [props?.reload]);

    useEffect(() => {
        if (rows != null) {
            // if null its initialiser stage, dont update because it will update original values in parent
            props.updateValue(props.field, getMergedInputValues())
        }
    }, [rows])

    const getMergedInputValues = () => {
        var filtered = rows.filter(function (row) {
            return row != null;
        });
        return filtered
    }

    const onEdit = (value, index, type) => {
        rows[index][type] = value
        setRows([...rows])
    }
    const onEditFieldValues = (value, index, type) => {
        rows[index][type] = [value]
        setRows([...rows])
    }


    const getInputItem = (value, index) => {
        return <div className='rows' key={index}>
            <div className="row" >
                <SpaceBetween direction="horizontal" >
                    <Input
                        onChange={({ detail }) => onEdit(detail.value, index, 'label')}
                        value={value['label']}
                        placeholder='Key'

                    />
                    <Input
                        onChange={({ detail }) => onEditFieldValues(detail.value, index, 'field_values')}
                        value={value['field_values'][0]}
                        placeholder='Value'
                    />
                </SpaceBetween>
            </div>
            <div className="row"><Button iconName="close" variant="icon" onClick={() => {
                deleteRow(index)
            }} /></div>
        </div>
    }
    const deleteRow = (index) => {
        rows.splice(index, 1)
        setRows([...rows])
    }

    const addRow = () => {
        setRows([...rows, { 'field_type': 'ripple_input', 'field_values': [], 'label': '' }])
    }
    const getAddButton = () => {
        return <div> <Button onClick={addRow}>Add</Button> </div>
    }

    const loadRows = () => {
        let values = props.getValues(props.field)
        if (values) {
            setRows(values)
        } else {
            setRows([])
        }

    }

    return (
        <SpaceBetween direction="vertical">

            {rows ? (Array.from(rows).map((value, index) => {
                return getInputItem(value, index);
            })) : ''}

            {
                getAddButton()
            }
        </SpaceBetween>
    )
}

export default RippleMultiInputKeyValue;